<ul class="pagination">
    <li class="page-item pointer"
        [ngClass]="{'active': currentPage === page,
                 'last': (pages[pages.length - 1] === page && pages[pages.length - 1] - pages[pages.length - 2] > 1),
                 'first': (pages[0] === page && pages[1] - pages[0] > 1)}"
        *ngFor="let page of pages; trackBy: trackByFunction"
        (click)="onClick(page)">
        <div class="page-link">{{ page }}</div>
    </li>
</ul>